<template>
    <div id="app">
        <Notifications />
        <router-view />
    </div>
</template>
<script>
import Notifications from './components/tools/Notifications'
export default {
    components: { Notifications }
}
</script>
<style lang="scss">
@import '@/assets/scss/bulma.scss';

@font-face {
    font-family: 'Regular';
    src: url(/Poppins-Regular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'SemiBold';
    src: url(/Poppins-SemiBold.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
}
html,
body {
    margin: 0;
    height: 100%;
    width: auto;
    position: device-fixed;
    overflow: hidden;
    max-width: 100%;
    font-size: calc(0.4em + 0.5vw);

    @media (max-width: 1000px) {
        font-size: calc(0.5em + 1.2vw);
    }
}
button {
    border: none;
    cursor: pointer;
    outline: none;
}

input:not([type='checkbox']) {
    appearance: none;
    border-radius: 0;
}

a {
    text-decoration: none;
}
i {
    user-select: none;
}
* {
    box-sizing: border-box;
    &:focus {
        outline: none;
    }
}
table,
tr,
th,
td {
    border-radius: 12px !important;
}
#app {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    height: 100%;
    font-family: 'Regular', Helvetica, Arial, sans-serif;
}

* {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.login-subtitle {
    margin-top: 0.2rem;
}
.login-view {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: #fff;
    color: #505050;
    font-family: $input-family;
    overflow: hidden;

    &::after {
        content: '';
        background: url('./assets/img/login-background.svg');
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;

        @media (max-width: 1000px) {
            opacity: 0.3;
        }
    }
}
.login-form-overflow {
    width: 100%;
    height: 100%;
    padding: 4rem 8rem;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    max-height: 100%;
    z-index: 1000;

    @media (max-width: 1300px) {
        padding: 1rem 8rem;
    }
    @media (max-width: 1000px) {
        padding: 0;
    }
}
.login-form-button {
    margin-top: 1rem;
    text-align: center;
}
.login-form {
    display: flex;
    flex-direction: column;
    width: 30%;
    z-index: 1000;
    min-width: 300px;

    @media (max-width: 1000px) {
        overflow-y: auto;
        width: 100%;
        padding: 1.5rem;
        box-sizing: border-box;
    }
}
.login-logo {
    width: 100%;
}
.login-greeting {
    margin-top: 3rem;
    font-size: 2.1rem;
    font-family: 'SemiBold';
}
.login-comment-action {
    margin-left: auto;
    margin-top: 0.7rem;
    cursor: pointer;
    transition: $ease;
    font-family: $input-family;
    font-size: 0.9rem;
    color: $input;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-button {
    margin: 0 auto;
    color: $light-accent;
    padding: 0.3rem 1rem;
    border-radius: 5rem;
    cursor: pointer;
    font-size: 1.1rem;
    transition: $ease;
    user-select: none;
    font-family: $input-family;
    background: $action-accent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 2.5rem;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    max-width: 500px !important;
    width: 90%;

    @media (max-width: 1000px) {
        padding: 0.2rem 0.5rem;
        width: 80%;
    }

    &:last-of-type {
        margin-right: 0;
    }

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-actions-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    font-size: 0.9rem;
}
.login-action {
    cursor: pointer;
    transition: $ease;
    color: $input;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-border {
    width: 50%;
    margin: 2rem auto;
    border-bottom: 0.1rem solid $light;
}
.login-comment {
    color: $input;
    font-size: 0.95rem;
}
.app-store-badge {
    height: 3rem;
    cursor: pointer;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }

    &:last-of-type {
        margin-left: 1rem;
    }
}
.login-laurel {
    position: absolute;
    top: 8rem;
    right: 8rem;
    z-index: $high;
}
.login-type-box {
    border: $input-border;
    border-radius: $small-radius;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    transition: $ease;
    height: 100%;
    padding: 0.5rem;
    overflow: hidden;
    box-sizing: border-box;

    img {
        height: 5rem;
        margin: 0.2rem;
    }

    &.-small {
        height: 3rem;
        width: 3rem;
        font-size: 0.3rem;
        padding: 0;

        img {
            height: 90%;
            width: 90%;
            margin: 0.1rem;
        }
    }

    &.-purple {
        color: $accent-purple;

        &.-active {
            border-color: $accent-purple;
        }

        &:hover {
            border-color: $accent-purple;
        }
    }
    &.-orange {
        color: $accent-orange;

        &.-active {
            border-color: $accent-green;
        }
        &:hover {
            border-color: $accent-orange;
        }
    }
    &.-green {
        color: $accent-green;

        &.-active {
            border-color: $accent-green;
        }

        &:hover {
            border-color: $accent-green;
        }
    }
    &.-blue {
        color: $accent-blue;

        &.-active {
            border-color: $accent-blue;
        }

        &:hover {
            border-color: $accent-blue;
        }
    }
    &.-signup {
        flex-direction: row;
        justify-content: flex-start;
        margin-bottom: 1rem;
        font-size: 1.4rem;

        img {
            margin-right: 1rem;
        }

        &:not(:first-of-type) {
            margin-left: 0;
        }
    }

    &:not(:first-of-type) {
        margin-left: 1rem;
    }
}
.upload-progress-bar {
    width: 100%;
    height: 0.4rem;
    position: relative;
    opacity: 0;
    border-radius: $input-radius;
    overflow: hidden;
    transition: $ease;
    background: rgba(155, 155, 155, 0.4);
    margin-top: 0.5rem;

    &.-visible {
        opacity: 1;
    }

    div {
        background: $action-accent;
        height: 100%;
    }
}
.signup-progress {
    display: flex;
    margin: 1rem 0;

    div {
        height: 15px;
        width: 15px;
        border-radius: 100%;
        background: $action-accent;
        margin-right: 0.8rem;
        opacity: 0.3;
    }
    &.-first {
        div {
            &:first-of-type {
                opacity: 1;
            }
        }
    }
    &.-second {
        div {
            opacity: 1;
            &:last-of-type {
                opacity: 0.3;
            }
        }
    }
    &.-third {
        div {
            opacity: 1;
        }
    }
}
.login-type-box div {
    bottom: 1rem;
}
.login-checkbox {
    display: flex;
    margin-top: 1rem;
    transition: $ease;
}
.login-checkbox span {
    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-checkbox-text {
    margin-left: 1rem;
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.login-message {
    font-size: 1.2rem;
    margin-top: 1rem;
}
.login-flag-row {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
}
.login-flag {
    height: 1.5rem;
    cursor: pointer;
    transition: $ease;
    margin-right: 0.5rem;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.chat-avatar {
    height: 4rem;
    width: 4rem;
    border-radius: 100%;
    flex-shrink: 0;
    position: relative;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 1rem;

    &.-small {
        height: 2.5rem;
        width: 2.5rem;
    }
    &.-very-small {
        height: 2rem;
        width: 2rem;
        margin-right: 0.8rem;
    }
}
.chat-panel {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.chat-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 2rem;
    box-sizing: border-box;
}
.chat-image {
    height: 25rem;
    max-height: 25rem;
    max-width: 100%;
    margin-bottom: 0.5rem;
}
.chat-image img {
    max-height: 25rem;
    max-width: 100%;
    border: $list-border;
    overflow: hidden;
    border-radius: $input-radius;
    box-sizing: border-box;
}
.target-info {
    display: flex;
    align-items: center;
}
.target-menu {
    display: flex;
    align-items: center;
    color: $smoked;
}
.target-menu i {
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.messages-list {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: $modal-radius;
    overflow-y: auto;
    position: relative;
    padding-bottom: 0;

    &.-empty {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.conversation {
    padding: 0rem 2rem;
    box-sizing: border-box;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.chat-message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;

    &.-right {
        align-items: flex-end;
    }
}
.navigation-search {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: $list-border;
    box-sizing: border-box;
    padding: 0.1rem;
    padding-left: 0.5rem;
    border-radius: $small-radius;

    transition: $ease;

    &:hover {
        border-color: darken($border-accent, 10%);
    }
}
.navigation-search input {
    border: none;
    outline: none;
    height: 2rem;
    line-height: 1.2rem;
    font-size: 1.2rem;

    @media (max-width: 1000px) {
        max-width: 5rem;
    }

    &::placeholder {
        color: $input-placeholder;
    }
}
.navigation-search i {
    color: $input-placeholder;
    margin: 0.3rem 0.5rem;
}
.chat-panel {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.chat-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 2rem;
    box-sizing: border-box;
}
.target-info {
    display: flex;
    align-items: center;
}
.target-menu {
    display: flex;
    align-items: center;
    color: $smoked;
}
.target-menu i {
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.messages-list {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: $modal-radius;
    overflow-y: auto;
    position: relative;
    padding-bottom: 0;

    &.-empty {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.conversation {
    padding: 0rem 2rem;
    box-sizing: border-box;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.chat-message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;

    &.-right {
        align-items: flex-end;
    }
}

$message-border-radius: $small-radius;
.text {
    font-family: $input-family;
    max-width: 80%;

    padding: 1.5rem;
    flex-shrink: 0;

    background: #ebedf2;
    border-radius: $message-border-radius;

    &.-blue {
        background: $accent-apple;
        color: #ffffff;
    }
}
.author {
    margin: 0.25rem 0;
    margin-top: 0.5rem;
    font-size: 0.8rem;
    color: $smoked;
}
.row {
    width: 100%;

    display: flex;
    align-items: center;

    &.-right {
        flex-direction: row-reverse;
    }
}

.tooltip-wrap {
    max-height: 32px;
    margin-left: 10px;
    position: relative;
    display: none;
    align-items: center;

    &.-right {
        margin-left: 0;
        margin-right: 10px;
    }
}

.tooltip {
    padding: 3px 5px;

    background: #3a3a3a;
    color: #ffffff;
    font-size: 14px;
    font-weight: $medium;
    border-radius: 3px;

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 100%;
        margin-top: -4px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent #3a3a3a transparent transparent;
    }

    &.-right {
        &::after {
            right: -10px;
            border-color: transparent transparent transparent #3a3a3a;
        }
    }
}

.text:hover + .tooltip-wrap {
    display: flex;
}

.day {
    width: 100%;
    margin: 0.5rem 0;
    font-size: 0.8rem;
    text-transform: uppercase;
    text-align: center;
    color: $smoked;
    font-family: $input-family;
}
.message-input {
    display: flex;
    align-items: center;
    border-top: $list-border;
}
.message-input input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 1.3rem;
    font-family: $input-family;
    padding: 0.5rem 2rem;

    &::placeholder {
        color: $smoked;
    }
}
.attachment-input {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 2.2rem;
    box-sizing: border-box;
    color: $smoked;
    border-left: $list-border;
}
.attachment-input i {
    font-size: 2rem;
    cursor: pointer;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.input-confirm {
    padding: 2rem 2.2rem;
    box-sizing: border-box;
}
.input-confirm i {
    font-size: 2rem;
    color: $main-accent;
    cursor: pointer;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.smooth {
    scroll-behavior: smooth;
}
.-select-chat {
    margin-right: 1rem;
    cursor: pointer;
    transition: $ease;
    font-family: $input-family;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.closing-modal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: $high;
}
// ::-webkit-scrollbar {
//     width: 8px;
//     height: 8px;
// }

// /* Track */
// ::-webkit-scrollbar-track {
//     background: transparent;
//     border-radius: 10px;
// }

// /* Handle */
// ::-webkit-scrollbar-thumb {
//     background: rgb(184, 184, 184);
//     border-radius: 10px;
// }

// /* Handle on hover */
// ::-webkit-scrollbar-thumb:hover {
//     background: rgb(145, 145, 145);
// }
.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.15s;
    transition-property: opacity;
    transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
.list-enter-active,
.list-leave-active {
    transition: all 1s;
    opacity: 1;
}
.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(30px);
    transition: $ease;
}
.actions {
    text-align: center;
    margin-top: 1rem;
}
.edit-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    transition: $ease;
    box-sizing: border-box;
    border-radius: $small-radius;

    &:first-of-type {
        margin-top: 0;
    }
}
.section-selector {
    position: relative;
    width: 100%;
    border: $input-border;
    border-radius: $small-radius;
    margin-right: 0.5rem;
    transition: $ease;
    font-size: 1.2rem;
    padding: 0.45rem 0;
    height: 2.4rem;

    &.-success {
        border-color: $accent-green;
        background: rgba(46, 213, 116, 0.184);
    }
    &.-error {
        border-color: $accent-red;
        background: rgba(255, 71, 86, 0.212);
    }

    &.-disabled {
        color: $smoked !important;
        background: rgba(211, 211, 211, 0.281);
        pointer-events: none;
    }

    &.-focus {
        border-color: $main-accent;
    }
    input {
        padding: 0;
        margin: none;
        outline: none;
        width: 100%;
        height: 100%;
        font-size: 1.1rem;
        font-family: $input-family;
        transition: $ease;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        border: none;

        padding: 0 1rem;
        border-radius: $small-radius;
        margin-right: 0.5rem;
        background: transparent;

        &:focus {
            border-color: $accent-green;
        }

        &.-prefix {
            padding: 0 3rem 0 1rem;
        }

        &.-error {
            border-color: $accent-red;
            color: $accent-red;
            &::placeholder {
                color: rgb(150, 150, 150);
            }
        }
        &.-success {
            border-color: $accent-green;
        }

        &::placeholder {
            color: $input-placeholder;
        }
    }
}
.selector-container {
    height: 100%;
    transition: $ease;
    font-size: 1.1rem;
    font-family: $input-family;
    cursor: pointer;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    padding: 0 1rem;
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    border-radius: $small-radius;

    &.-list {
        padding: 0.5rem 0rem;
    }
}
.selector-body {
    background: $background;
    z-index: $highest;
    position: fixed;
    max-height: 100%;
    overflow: hidden;
    overflow-y: auto;
    border: 0.1rem solid $border-accent;
    margin-left: -0.1rem;

    border-radius: $small-radius;
}
.body-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.7rem;
    user-select: none;
    transition: $ease;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.-add {
        color: $action-accent;
        border-top: 0.1rem solid $border-accent;
        cursor: pointer;
        font-family: $input-family;
        &:hover {
            background: darken($background, 2%);
        }
    }
}
.button-loader {
    width: 64px;
    height: 11px;

    display: inline-block;
    position: relative;
}

.button-loader div {
    position: absolute;
    top: 0;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.button-loader div:nth-child(1) {
    left: 6px;
    animation: button-loader1 0.6s infinite;
}

.button-loader div:nth-child(2) {
    left: 6px;
    animation: button-loader2 0.6s infinite;
}

.button-loader div:nth-child(3) {
    left: 26px;
    animation: button-loader2 0.6s infinite;
}

.button-loader div:nth-child(4) {
    left: 45px;
    animation: button-loader3 0.6s infinite;
}
@keyframes button-loader1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes button-loader3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}

@keyframes button-loader2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(19px, 0);
    }
}
.popup-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: $highest;
    transition: $ease;

    &.-hidden {
        pointer-events: none;
    }
}
.popup-modal {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $high;
    cursor: pointer;
    background: $modal-background;
    transition: all 0.5s ease;
}
.popup-content {
    padding: 1rem;
    overflow-y: auto;
    position: relative;
    box-sizing: border-box;
    background: #fff;
    box-shadow: $modal-shadow;
    border-radius: $small-radius;
    width: 50%;
    min-width: 200px;
    max-height: 85%;
    margin: 58px 0;
    z-index: $highest;

    &.-list {
        width: 80%;
    }

    &.-small {
        width: 40%;
    }

    @media (max-width: 1300px) {
        width: 90% !important;
    }
    @media (max-width: 1000px) {
        width: 95% !important;
    }
}
.flex-row {
    display: flex;
    align-items: center;

    &.-between {
        justify-content: space-between;
    }
    &.-center {
        justify-content: center;
    }
    &.-around {
        justify-content: space-around;
    }
}
</style>
